import React, { useState } from 'react';
import { Toggle } from '@clientos/ui-toolkit';

const PrinterConsentsToggle = ({ initialState, onChange, ariaLabel }) => {

  const [toggleState, setToggleState] = useState(initialState);

  const handleChange = (e) => {
    setToggleState(e);
    onChange(e);
  }

  return (
    <Toggle
      data-testid="setAnalytics-btn"
      id="app-analytics-toggle"
      role="switch"
      aria-label={ariaLabel}
      aria-checked={toggleState}
      on={toggleState}
      onChange={handleChange}
    />
  );
};

export default PrinterConsentsToggle;